module.exports = __webpack_public_path__ + "static/media/wave-square.e526e331.svg";